import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import debounce from 'lodash/debounce';
import Loader from "../Loader";
import { notificationHelper } from "../../utils/helper";
import styles from './LookupHelper.module.scss';
const {
  Option,
  OptGroup
} = Select;
const LookupHelper = _ref => {
  let {
    onChange,
    apiCall,
    defaultValue,
    placeholder,
    groupChildKey,
    labelKey,
    idKey,
    valueKey,
    isGroup,
    responseKey,
    debounceTime,
    className
  } = _ref;
  const [data, setData] = useState([]);
  const [value, setValue] = useState(defaultValue ? {
    label: defaultValue,
    key: defaultValue
  } : undefined);
  const [loading, setLoading] = useState(false);
  const fetchLookupData = debounce(async value => {
    if (!value) return null;
    setData([]);
    setLoading(true);
    try {
      const data = await apiCall(value);
      let response = data;
      if (responseKey) response = data[responseKey];
      setData(response);
      setLoading(false);
    } catch (error) {
      notificationHelper('error', __('Error fetching lookup data'), ' ', 5, () => {}, '');
      setLoading(false);
    }
  }, debounceTime);
  const renderOptions = () => {
    if (!data) return null;
    return data.map(user => {
      if (!isGroup) {
        return /*#__PURE__*/React.createElement(Option, {
          key: user[idKey],
          value: user[valueKey]
        }, "".concat(user[labelKey], " <").concat(user[valueKey], ">"));
      } else {
        var _user$groupChildKey;
        return /*#__PURE__*/React.createElement(OptGroup, {
          key: user[idKey],
          label: user[labelKey]
        }, /*#__PURE__*/React.createElement(Option, {
          className: styles.group,
          label: user[labelKey],
          value: user[idKey]
        }, user[labelKey]), ((_user$groupChildKey = user[groupChildKey]) === null || _user$groupChildKey === void 0 ? void 0 : _user$groupChildKey.length) && user[groupChildKey].map(member => /*#__PURE__*/React.createElement(Option, {
          key: "".concat(user[idKey], "\\").concat(member[valueKey]),
          label: "".concat(user[labelKey], "\\").concat(member[labelKey]),
          value: "".concat(user[idKey], "\\").concat(member[valueKey])
        }, "".concat(user[labelKey], "\\").concat(member[labelKey]))));
      }
    });
  };
  const handleChange = val => {
    setData([]);
    setValue(val);
    setLoading(false);
    onChange((val === null || val === void 0 ? void 0 : val.key) || val);
  };
  const selectLoader = () => /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '50px'
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    id: "select-lookup-Loader"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Select, {
    allowClear: true,
    className: className,
    mode: "default",
    labelInValue: true,
    showSearch: true,
    value: value || undefined,
    notFoundContent: loading ? selectLoader() : null,
    filterOption: false,
    placeholder: placeholder,
    onSearch: fetchLookupData,
    onChange: handleChange,
    style: {
      width: '100%'
    },
    getPopupContainer: trigger => trigger.parentNode
  }, renderOptions()));
};
LookupHelper.propTypes = {
  onChange: PropTypes.func.isRequired,
  apiCall: PropTypes.func.isRequired,
  labelKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  groupChildKey: PropTypes.string,
  idKey: PropTypes.string,
  isGroup: PropTypes.bool,
  responseKey: PropTypes.string,
  className: PropTypes.string
};
LookupHelper.defaultProps = {
  defaultValue: '',
  placeholder: 'Search here',
  groupChildKey: 'notify',
  isGroup: false,
  idKey: 'id',
  debounceTime: 500,
  className: 'createTicket_input'
};
export default LookupHelper;